import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	select: {
		marginTop: -2.5,
		marginBottom: -2.5,
	},
	row: {
		marginTop: 2.5,
		marginBottom: 2.5,
	},
});
